export default {
  'register-invoiced': 'Registrar datos de facturación',
  'assign-products': 'Asignar inspector',
  'edit-service': 'Editar servicio'
};
